import { ListItemIcon, MenuItem, Menu, Button } from "@mui/material";
import { useState, MouseEvent } from "react";

import { withForm } from "components/Forms/AppForm";

import { defaultProductUpdateValues } from "../../defaultValues";

import { severityOptions, SeverityOptionData } from "./data/severityOptions";

const SeveritySelect = withForm({
  defaultValues: defaultProductUpdateValues,
  render: ({ form }) => {
    // eslint doesn't like hooks in a render method that is not the top level of the component
    // eslint-disable-next-line
    const [menuAnchorRef, setMenuAnchorRef] = useState<null | HTMLElement>(
      null,
    );
    const open = Boolean(menuAnchorRef);
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      setMenuAnchorRef(event.currentTarget);
    };
    const handleClose = () => {
      setMenuAnchorRef(null);
    };

    return (
      <form.AppField name="severity">
        {(field) => (
          <>
            <form.Subscribe selector={(state) => state.values.severity}>
              {(severity) => {
                const selected = severityOptions[severity];
                const SelectedIcon = selected.Icon;
                const color = selected.color;
                return (
                  <Button
                    onClick={handleClick}
                    variant="outlined"
                    sx={{ flex: 0, padding: 0 }}
                    color={color}
                  >
                    <SelectedIcon color={color} />
                  </Button>
                );
              }}
            </form.Subscribe>

            <Menu
              open={open}
              anchorEl={menuAnchorRef}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              sx={{ pt: 0 }}
            >
              {severityOptions.map(({ id, color, Icon }) => {
                const handleChange = () => {
                  field.handleChange(id);
                  setMenuAnchorRef(null);
                };

                return (
                  <SeverityOption
                    key={id}
                    id={id}
                    color={color}
                    Icon={Icon}
                    onSelect={handleChange}
                    selected={id === field.state.value}
                  />
                );
              })}
            </Menu>
          </>
        )}
      </form.AppField>
    );
  },
});
export default SeveritySelect;

interface SeverityOptionProps extends SeverityOptionData {
  selected: boolean;
  onSelect: () => void;
}

const SeverityOption = ({
  color,
  Icon,
  selected,
  onSelect,
}: SeverityOptionProps) => {
  return (
    <MenuItem selected={selected} onClick={onSelect} sx={{ px: 1 }}>
      <ListItemIcon sx={{ justifyContent: "center" }}>
        <Icon color={color} />
      </ListItemIcon>
    </MenuItem>
  );
};
